import React, { Component } from 'react';
import { Tag } from 'antd';
import Configuration from '../../Configuration.js';

class VisitVisitorDetails extends Component {
  render() {
    // List visitors
    const visitors = this.props.visit.visitors.map(visitor => {
      return (
        <Tag color="blue" key={`visitor:${visitor.id}`}>{visitor.name}</Tag>
      );
    });

    // Render components
    return (
      <div className="visit-details-wrapper">
        <div className="visit-details d-flex flex-column">
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Folio:</h6>
            <span className="text-muted">#{this.props.visit.folio}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Asunto:</h6>
            <span className="text-muted">{this.props.visit.subject}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Detalles:</h6>
            <span className="text-muted">{this.props.visit.details}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Visita a:</h6>
            <span className="text-muted">{this.props.visit.profile.names}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Visitantes:</h6>
            <span className="text-muted">{visitors}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Fecha de cita:</h6>
            <span className="text-muted">{Configuration.formatDatetime(this.props.visit.due_date)}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Fecha de llegada:</h6>
            <span className="text-muted">{Configuration.formatDatetime(this.props.visit.arrive_date)}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Fecha de salida:</h6>
            <span className="text-muted">{Configuration.formatDatetime(this.props.visit.leave_date)}</span>
          </div> 
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Tiempo de permanencia:</h6>
            <span className="text-muted">{Configuration.stayTime(this.props.visit.arrive_date, this.props.visit.leave_date)}</span>
          </div>
          <div className="visit-details-item d-flex flex-column">
            <h6 className="m-0 text-muted">Usuario de creación:</h6>
            <span className="text-muted">{this.props.visit.profile.names}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default VisitVisitorDetails;



// WEBPACK FOOTER //
// ./src/components/access/VisitVisitorDetails.js